import React from 'react';
import Select from 'react-select';
import { User, AlertCircle } from 'lucide-react';


const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#D97706' : '#E5E7EB',
    boxShadow: state.isFocused ? '0 0 0 1px #D97706' : 'none',
    '&:hover': { borderColor: '#D97706' },
    borderRadius: '0.375rem',
    padding: '0.125rem',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#FEF3C7',
    borderRadius: '0.25rem',
    padding: '0 0.25rem',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#92400E',
    fontSize: '0.75rem',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#92400E',
    ':hover': { backgroundColor: '#FEE2E2', color: '#B91C1C' },
  }),
};

export default function DeveloperMultiSelect({ options, value, onChange, error , disabled =true}) {
  return (
    <div className="mb-3">
      <label className="block text-xs font-medium text-gray-600 mb-1 flex items-center">
        <User size={14} className="text-terrecuite mr-1" />
        Développeurs
      </label>
      <Select
        isMulti
        isDisabled={disabled}
        options={options}
        value={options.filter(o => value.includes(o.value))}
        onChange={selected =>
          onChange({
            target: {
              name: 'developpeur_ids',
              value: selected.map(s => s.value),
            },
          })
        }
        styles={customStyles}
        placeholder="Choisir des développeurs..."
        className="text-xs"
      />
      {error && (
        <p className="mt-1 text-xs text-red-500 flex items-center">
          <AlertCircle size={12} className="mr-1" />
          {error}
        </p>
      )}
    </div>
  );
}
